<div class="upload-container">
  <div class="upload-card">
    <div class="logo-wrapper">
      <img src="images/uiConcept/Logos/Dark/Logo_V1_Dark.png" alt="Gity" />
    </div>

    <!-- Show while validating -->
    <div *ngIf="isValidating" class="validating">
      <div class="spinner"></div>
      <p>Validating QR Code...</p>
    </div>

    <!-- Main content -->
    <ng-container *ngIf="!isValidating">
      <!-- Upload Allowed -->
      <ng-container *ngIf="uploadAllowed; else notAllowed">
        <p class="subtitle">
          Select a scan or image from your phone and upload it securely.
        </p>

        <!-- Upload Progress -->
        <div class="upload-progress" *ngIf="isUploading">
          <div class="spinner"></div>

          <div class="progress-text">
            Uploading {{ currentUploading }} of {{ selectedFiles.length }}
          </div>

          <div class="current-file">
            {{ currentFileName }}
          </div>

          <div class="progress-bar">
            <div class="progress-fill" [style.width.%]="overallPercent"></div>
          </div>

          <div class="percent">{{ overallPercent }}%</div>
        </div>

        <!-- Upload Completed -->
        <div class="upload-complete" *ngIf="uploadingCompleted">
          ✅ Upload Complete!
        </div>

        <!-- File Picker -->
        <div *ngIf="!isUploading">
          <label class="file-upload">
            <input
              #fileInput
              type="file"
              accept="*/*"
              multiple
              hidden
              (change)="selectFiles($event)"
            />

            <button
              type="button"
              class="choose-btn"
              (click)="fileInput.click()"
            >
              Choose Files
            </button>
          </label>

          <div class="selected-files" *ngIf="selectedFiles.length">
            <div class="selected-file" *ngFor="let file of selectedFiles">
              <span class="file-icon">📄</span>

              <span class="file-name">
                {{ file.name }}
              </span>

              <span class="file-size"> ({{ formatFileSize(file.size) }}) </span>
            </div>
          </div>

          <button
            class="upload-btn"
            [disabled]="!selectedFiles.length"
            (click)="upload()"
          >
            Upload
          </button>
        </div>
      </ng-container>

      <!-- Upload Not Allowed -->
      <ng-template #notAllowed>
        <div class="error-card">
          <div class="error-icon">⚠️</div>

          <h3>Upload Not Available</h3>

          <p>{{ errorMessage }}</p>
        </div>
      </ng-template>
    </ng-container>
  </div>
</div>
